import { siteInfo } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50 pt-[72px]">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-5">
              🔥 800万+漫友的共同选择
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              漫漫漫画<span className="text-primary-500">·</span>海量免费漫画平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-6">
              下拉式阅读 · 日更百话 · 韩漫日漫国漫全覆盖
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              漫漫漫画汇集<span className="font-semibold text-foreground-800">十万余部免费漫画</span>，覆盖韩漫、日漫、国漫三大品类。
              每日<span className="font-semibold text-foreground-800">更新超过 500 话</span>，热门作品官方更新后一小时内同步上线。
              无论是热血少年漫、恋爱甜漫还是悬疑推理，下拉式流畅阅读体验让您沉浸在漫画世界里——
              <span className="font-semibold text-foreground-800">看漫画，不花钱，漫漫与您一路相伴。</span>
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{siteInfo.stats.total}</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">{siteInfo.stats.daily}</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">{siteInfo.stats.users}</div>
                <div className="text-xs text-foreground-500 mt-1">漫友聚集</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                立即开始阅读 —— 完全免费
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-foreground-700 bg-background-100 rounded-full hover:bg-background-200 transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-smartphone-line mr-1.5"></i>下载 APP 体验更佳
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/20 via-accent-200/15 to-secondary-200/20 rounded-2xl blur-xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20illustration%20style%20artwork%20featuring%20a%20powerful%20male%20warrior%20with%20flowing%20dark%20hair%20and%20glowing%20eyes%2C%20dramatic%20action%20pose%20with%20energy%20effects%2C%20warm%20orange%20and%20red%20tones%2C%20intricate%20lineart%2C%20Japanese%20anime%20aesthetic%2C%20dark%20background%20with%20particle%20effects%2C%20epic%20composition%2C%20high%20contrast%2C%20professional%20manga%20cover%20quality&width=600&height=800&seq=hero-manga-01&orientation=portrait"
                  alt="热血战斗漫画"
                  className="w-full rounded-xl object-cover aspect-[3/4] object-top"
                />
                <div className="flex flex-col gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20beautiful%20romance%20manga%20style%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20pastel%20tones%2C%20Korean%20webtoon%20aesthetic%2C%20delicate%20linework%2C%20dreamy%20atmosphere%2C%20gentle%20lighting%2C%20romantic%20scene%2C%20clean%20composition&width=600&height=380&seq=hero-manga-02&orientation=landscape"
                    alt="恋爱漫画"
                    className="w-full rounded-xl object-cover aspect-[16/10] object-top"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20thrilling%20manga%20illustration%20of%20a%20mysterious%20detective%20character%20in%20a%20dimly%20lit%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20cool%20teal%20and%20deep%20blue%20tones%2C%20Japanese%20manga%20style%2C%20suspenseful%20composition%2C%20high%20detail%20lineart&width=600&height=380&seq=hero-manga-03&orientation=landscape"
                    alt="悬疑漫画"
                    className="w-full rounded-xl object-cover aspect-[16/10] object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}